import { AppBundle } from 'api/optimalprint-sdk.d';
import { PricesToFetch } from 'store/price/types';
import { groupBy } from 'lodash';

const collectPricesFromSimilarProducts = (products: AppBundle.Api.Entity.Design.V1.ISimilarProduct[]) => {
  const productsGroupedByCategory = groupBy(products, 'categoryId');

  const mappedToPricesToFetch: PricesToFetch = {};

  Object.keys(productsGroupedByCategory).forEach((key) => {
    mappedToPricesToFetch[+key] = {
      categoryId: +key,
      productIds: productsGroupedByCategory[key].map((element) => element.productId),
      encryptedDesignId: '',
    };
  });

  const result: PricesToFetch = mappedToPricesToFetch;

  return result;
};

export default collectPricesFromSimilarProducts;
